<template>
  <div class="">
    <div class="wrap-time-setting p-4 box-border"> 
      <div class="mb-4 flex text-medium text-theme-black-850 leading-22 font-normal" v-if="drawerType=='cell'">
        <p class="wh-70 text-right">单元格：</p>
        <div>{{cellsData.indicatorDimensionName}}-{{cellsData.timeDimensionName}}</div>
      </div>
      <div class="flex mb-4 text-medium text-theme-black-850 leading-22 font-normal">
        <p class="wh-70 text-right">数据源：</p>
        <div v-if="drawerType=='cell'">{{cellsData.sourceSurveyTitle}}</div>
        <div v-else-if="drawerType=='col'">{{cellsData.surveyTitle}}</div>
        <div v-else-if="drawerType=='row'">
          <span v-show="cellsData.commonSurveyId">{{cellsData.commonSurveyTitle}}</span>
          <span v-show="!cellsData.commonSurveyId">
            <span v-for="(source,i) of cellsData.sourceList" :key="source.timeDimensionId">
              <span>{{source.timeDimensionName}}{{source.surveyTitle}}</span>
              <span v-show="i!=cellsData.sourceList.length-1">、</span>
            </span>
          </span>
        </div>
      </div>
      <!-- 数据范围 -->
      <div class=" mb-2 flex items-center">
        <p class="wh-70 text-right text-medium text-theme-black-850 leading-22 font-normal">数据范围：</p>
        <el-radio-group v-model="cellsData.filter.isComplexFilter" @input="changeFilter" size="mini">
          <el-radio-button :label="false" :disabled="!indexStatInfo.surveyId && !cellsData.commonSurveyId && !cellsData.surveyId && !cellsData.sourceSurveyId">匹配选项</el-radio-button>
          <el-radio-button :label="true">设置条件</el-radio-button>
        </el-radio-group>
      </div>
      <div style="background: #F5F5F5;">
          <!-- 单元格配置 -->
        <div v-if="drawerType=='cell'" class="py-3 px-4">
          <!-- 设置条件 -->
          <div v-if="cellsData.filter.isComplexFilter">
            <condition-wrapper :disabled="false">
              <condition-container
                :condition="condition"
                :question-list="questionList"
                :show-survey-list="true"
                :survey-list="surveyList"
                :option="{ isEdit: true}"
              />
            </condition-wrapper>
            <el-button class="mt-3" type="text" size="small" @click="clearAllCondition"
            >清空</el-button >
          </div>
          <!-- 匹配选项 -->
          <div v-else class="flex items-center">
            <p class="mr-2 text-medium text-theme-black-650 leading-22 font-normal">数据字段：</p>
            <select-list 
            root="range"
            :surveyList="surveyList" 
            :surveyId.sync="cellsData.filter.simpleFilter.surveyId"
            :questionId.sync="cellsData.filter.simpleFilter.questionId"
            :optionIds.sync="cellsData.filter.simpleFilter.optionIds"
            :questionType.sync="cellsData.filter.simpleFilter.questionType"
            :isSample.sync="cellsData.filter.simpleFilter.isSample"
            ></select-list>
          </div>
        </div>
        <!-- 批量配置 -->
        <div v-else>
          <!-- 复杂-设置条件 -->
          <div v-if="cellsData.filter.isComplexFilter" class="py-3 px-4">
              <div v-for="(item,i) of cellsData.filter.dimensionComplexFilterList" :key="item.dimensionId" class="px-4 py-3 bg-white mb-3 " >
                  <p class="text-medium text-theme-black-850 leading-22 font-normal mb-2">{{item.dimensionName}}</p>
                  <condition-wrapper :disabled="false">
                    <condition-container
                      :condition="item.filter"
                      :question-list="questionList"
                      :survey-list="item.surveyList"
                      :show-survey-list="true"
                      :option="{ isEdit: true }"
                    />
                  </condition-wrapper>
                  <div class="mt-3">
                    <el-button v-if="i!=0 && (cellsData.surveyId || cellsData.commonSurveyId)"  type="text" size="small" @click="copyLast(i)">复制上一个条件</el-button >
                    <el-button type="text" size="small" @click="clearItemAllCondition(i)">清空</el-button >
                  </div>
              </div>
          </div>
          <!-- 简单-匹配选项 -->
          <div v-else class="py-3">
            <data-table  ref="tableRef" class="w-full h-full overflow-hidden index-setting-table"
              cell-class-name="truncate-table-cell-wrap" align="left" :data="cellsData.filter.simpleFilter.dimensionOptionList" rowKey="dimensionId"
              :loading="tableLoading" :columns="dataRangeColumns" :page="page"
              selection :selectFixed="false" selectWidth="30" @selection-change="changeSelected">
              <template slot="headOptions">
                <div class="flex items-center justify-end" style="margin-right:-6px">
                  <span class="mr-2">选择字段</span>
                  <template v-if="cellsData.filter.simpleFilter">
                    <select-list 
                      root="range"
                    :surveyList="surveyList" 
                    :surveyId.sync="cellsData.filter.simpleFilter.surveyId"
                    :questionId.sync="cellsData.filter.simpleFilter.questionId"
                    :questionType.sync="cellsData.filter.simpleFilter.questionType"
                    :isSample.sync="cellsData.filter.simpleFilter.isSample"
                    :optionsList.sync="optionsList"
                    :showOptionSelsct="false"
                    @clearOptionIds="clearOptionIds"
                    surveySelectWidth='271px'
                    quesSelectWidth='128px'
                    ></select-list>
                  </template>
                </div>
              </template>
              <template slot="options"  slot-scope="{ row }">
                <el-select class="select-bg-white" style="width:271px" select-bg-white v-model="row.optionIds" :disabled="row.disableSel" placeholder="请选择选项">
                  <el-option :label="item.content.text" :value="item.id" v-for="item in optionsList" :key="item.id">
                  </el-option>
                </el-select>
              </template>
              <template #empty>
                <slot name="empty" v-if="$slots['empty']"></slot>
                <el-empty v-else></el-empty
                ><!-- 默认：图片+暂无数据 -->
              </template>
              <template #page-left>
                <div class="w-full mb-3" style="height:1px; background-color:#E7E9EB; margin-top:-6px"></div>
                <div class="flex items-center justify-between" >
                  <p class="mx-3 text-medium text-theme-black-650">
                    <el-checkbox v-model="checkPageAll" style="margin-left:2px">
                      <span class="ml-1">已选择 <span class="text-theme">{{ selectList.length }}</span> 项</span>
                    </el-checkbox>
                  </p>
                  <el-select style="margin-right: 12px;width:271px" class="select-bg-white" :disabled="selectList.length==0" v-model="allSelectDemo"  @change="changeBatchSel" placeholder="请选择选项">
                    <el-option :label="item.content.text" :value="item.id" v-for="item in optionsList" :key="item.id">
                    </el-option>
                  </el-select>
                </div>
              </template>
            </data-table>
          </div>
         
        </div>
      </div>

      <!-- 计算公式 -->
      <div class="flex mt-4 mb-2 items-center">
          <p class="wh-70 text-medium text-theme-black-850 leading-22 font-normal">计算公式：</p>
          <div v-if="drawerType!='cell'">
            <el-radio-group v-model="cellsData.formula.isDiffField" @input="changeFormula" size="mini">
              <el-radio-button :label="true">不同字段计算</el-radio-button>
              <el-radio-button :label="false" :disabled="!Boolean(cellsData.surveyId) && !Boolean(cellsData.commonSurveyId)" >相同字段计算</el-radio-button>
            </el-radio-group>
          </div>
          <div v-if="drawerType=='cell'">
            <el-radio-group v-model="cellsData.formula.isComplexFormula" @input="changeFormula" size="mini">
              <el-radio-button :label="false">简单计算</el-radio-button>
              <el-radio-button :label="true">复杂计算</el-radio-button>
            </el-radio-group>
          </div>
      </div>
      <div style="background: #F5F5F5;">
        <div v-if="drawerType=='cell'" class="py-3 px-4">
          <div v-if="cellsData.formula.isComplexFormula" class="flex items-center">
            <div class="mr-2 text-medium text-theme-black-650 leading-22 font-normal">表达式：</div>
            <div class="bg-white flex-1">
              <complex-calculation :timeSurveyId="cellsData.sourceSurveyId" :initialValue.sync="cellsData.formula.complexFormulaHtml" :initialValueText.sync="cellsData.formula.complexFormulaText"></complex-calculation>
            </div>
          </div>
          <div v-else>
            <div class="flex mb-2 items-center">
              <p class="mr-2 text-medium text-theme-black-650 leading-22 font-normal">数据字段：</p>
              <select-list 
                root="calcul"
              :showSurveySelsct="false"
              :surveyId.sync="cellsData.sourceSurveyId"
              :questionId.sync="cellsData.formula.simpleFormula.questionId"
              :optionIds.sync="cellsData.formula.simpleFormula.optionIds"
              :questionType.sync="cellsData.formula.simpleFormula.questionType"
              @changeQues="cellsData.formula.simpleFormula.funcName=''"
              ></select-list>
            </div>
            <div class="flex items-center">
              <p class="mr-2 text-medium text-theme-black-650 leading-22 font-normal">计算方式：</p>
              <el-select v-model="cellsData.formula.simpleFormula.funcName" placeholder="请选择" class="select-bg-white">
                <el-option
                  v-for="q of alculationMode(cellsData.formula.simpleFormula.questionType)"
                  :key="q.value"
                  :label="q.name"
                  :value="q.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <!-- 批量设置 -->
        <div v-else>
          <!-- 相同字段 -->
          <div v-if="!cellsData.formula.isDiffField" class="py-3 px-4">
            <div class="flex text-medium text-theme-black-450 leading-22 font-normal mb-2">
              <div style="width:130px" class="mr-2">维度</div>
              <div style="width:130px" class="mr-2">简单/复杂计算</div>
              <div class="mr-2 flex-1" v-show="!cellsData.formula.sameFieldIsComplexFormula">数据字段</div>
              <div style="width:130px" v-show="!cellsData.formula.sameFieldIsComplexFormula">计算方式</div>
              <div class="flex-1" v-show="cellsData.formula.sameFieldIsComplexFormula">表达式</div>
            </div>                                          
            <div class="flex items-center">
              <div style="width:130px" class="mr-2 text-medium text-theme-black-650">{{drawerType=='col'?cellsData.timeDimensionName:cellsData.indicatorDimensionName}}</div>
              <el-select style="width:130px" class="mr-2 select-bg-white" v-model="cellsData.formula.sameFieldIsComplexFormula" placeholder="请选择">
                <el-option
                  label="简单计算"
                  :value="false">
                </el-option>
                <el-option
                  label="复杂计算"
                  :value="true">
                </el-option>
              </el-select>
              <div class="flex-1 bg-white" v-if="cellsData.formula.sameFieldIsComplexFormula">
                <complex-calculation
                  :timeSurveyId="cellsData.surveyId|| cellsData.commonSurveyId" 
                  :initialValue.sync="cellsData.formula.sameFieldComplexFormulaHtml"
                  :initialValueText.sync="cellsData.formula.sameFieldComplexFormulaText"
                ></complex-calculation>
              </div>
              <div v-else  class="flex-1 flex justify-between">
                <select-list 
                root="calcul"
                :showSurveySelsct="false"
                :surveyId.sync="cellsData.surveyId || cellsData.commonSurveyId"
                :questionId.sync="cellsData.formula.sameFieldSimpleFormula.questionId"
                :optionIds.sync="cellsData.formula.sameFieldSimpleFormula.optionIds"
                :questionType.sync="cellsData.formula.sameFieldSimpleFormula.questionType"
                @changeQues="cellsData.formula.sameFieldSimpleFormula.funcName=''"
                ></select-list>
                <el-select class="ml-2 select-bg-white" style="width:130px" v-model="cellsData.formula.sameFieldSimpleFormula.funcName" placeholder="请选择">
                  <el-option
                    v-for="q of alculationMode(cellsData.formula.sameFieldSimpleFormula.questionType)"
                    :key="q.value"
                    :label="q.name"
                    :value="q.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div v-else class="diff-culcal-table py-3">
            <data-table ref="calculTableRef" class="w-full h-full overflow-hidden index-setting-table"
              cell-class-name="truncate-table-cell-wrap" align="left" :data="cellsData.formula.diffDimensionFormulaList"
              :loading="calculTableLoading" :columns="calculColumns" :page="calculpPage"
              selectWidth="30" :selectFixed="false" :selection="Boolean(cellsData.surveyId) || Boolean(cellsData.commonSurveyId)" @selection-change="changeCalculSelected" :showTooltip="false" rowKey="dimensionId"> 
              <template slot="calculType"  slot-scope="{ row }">
                <el-select style="width:128px" class="select-bg-white" v-model="row.formula.isComplexFormula" :disabled="row.disableSel" placeholder="请选择">
                  <el-option
                    label="简单计算"
                    :value="false">
                  </el-option>
                  <el-option
                    label="复杂计算"
                    :value="true">
                  </el-option>
                </el-select>
              </template>
              <template slot="formulaWay" slot-scope="{ row }">
                <div v-if="!row.formula.isComplexFormula" class="flex items-center">
                  <select-list 
                  root="calcul"
                  :showSurveySelsct="false"
                  :surveyId.sync="row.surveyId"
                  :questionId.sync="row.formula.simpleFormula.questionId"
                  :optionIds.sync="row.formula.simpleFormula.optionIds"
                  :questionType.sync="row.formula.simpleFormula.questionType"
                  :disabled="row.disableSel"
                  @changeQues="row.formula.simpleFormula.funcName=''"
                  ></select-list>
                  <el-select class="select-bg-white" style="width:130px" v-model="row.formula.simpleFormula.funcName" :disabled="row.disableSel" placeholder="请选择">
                    <el-option
                      v-for="q of alculationMode(row.formula.simpleFormula.questionType)"
                      :key="q.value"
                      :label="q.name"
                      :value="q.value">
                    </el-option>
                  </el-select>
                </div>
                <div v-if="row.formula.isComplexFormula" class="bg-white">
                  <complex-calculation
                    :positionType="String(row.dimensionId)"
                    :timeSurveyId="row.surveyId" 
                    :initialValue.sync="row.formula.complexFormulaHtml"
                    :initialValueText.sync="row.formula.complexFormulaText"
                    :contenteditable="!row.disableSel"
                    :tableComplu="true"
                  ></complex-calculation>
                </div>
              </template>
              <template #empty>
                <slot name="empty" v-if="$slots['empty']"></slot>
                <el-empty v-else></el-empty>
              </template>
              <template #page-left v-if="cellsData.surveyId || cellsData.commonSurveyId">
                <div class="w-full mb-3" style="height:1px; background-color:#E7E9EB; margin-top:-6px"></div>
                <div class="flex items-center" style="padding-right:10px">
                  <p class="ml-3 mr-24 text-medium text-theme-black-650" style="width:138px; margin-right:20px">
                    <el-checkbox v-model="calculCheckPageAll" style="margin-left:2px">
                      <span class="ml-1">已选择</span> <span class="text-theme">{{calculSelectList.length }}</span> 项
                    </el-checkbox>
                  </p>
                  <div style="width:128px; margin-right:20px"> 
                    <el-select style="width:128px" v-model="allCalculSel.isComplexFormula" :disabled="calculSelectList.length==0 " class="select-bg-white" placeholder="请选择" >
                    <el-option
                      label="简单计算"
                      :value="false">
                    </el-option>
                    <el-option
                      label="复杂计算"
                      :value="true">
                    </el-option>
                  </el-select>
                  </div>
                  <div v-show="!allCalculSel.isComplexFormula" class="flex items-center flex-1">
                    <select-list 
                    root="calcul"
                    :showSurveySelsct="false"
                    :surveyId.sync="cellsData.surveyId || cellsData.commonSurveyId"
                    :questionId.sync="allCalculSel.simpleFormula.questionId"
                    :optionIds.sync="allCalculSel.simpleFormula.optionIds"
                    :questionType.sync="allCalculSel.simpleFormula.questionType"
                    @changeQues="allCalculSel.simpleFormula.funcName=''"
                    :disabled="calculSelectList.length==0 "
                    ></select-list>
                    <el-select class="select-bg-white" style="width:130px" :disabled="calculSelectList.length==0 " v-model="allCalculSel.simpleFormula.funcName" placeholder="请选择">
                      <el-option
                        v-for="q of alculationMode(allCalculSel.simpleFormula.questionType)"
                        :key="q.value"
                        :label="q.name"
                        :value="q.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-show="allCalculSel.isComplexFormula" class="flex-1 bg-white">
                    <complex-calculation
                      positionType="allcalComplex"
                      :timeSurveyId="cellsData.surveyId || cellsData.commonSurveyId" 
                      :initialValue.sync="allCalculSel.complexFormulaHtml"
                      :initialValueText.sync="allCalculSel.complexFormulaText"
                    ></complex-calculation>
                  </div>
                </div>
              </template>
            </data-table>  
          </div>
        </div>
      </div>
      <preview-calcul :calculType="drawerType" :calcResultTable="cellsData.calcResultTable" :indicatorDimensionIds="indicatorDimensionIds" :timeDimensionIds="timeDimensionIds"></preview-calcul>
    </div>
    <div class="footer-btns flex justify-end p-4 bottom-0 box-border footer-time-btns bg-white z-50">
      <el-button class="primary-btn-style" type="primary" @click="toSubmit">提 交</el-button>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import DataTable from '@/components/base/DataTable'
import GlobalConfig from '@/global/config'
import { checkCondition } from '@/condition/utils'
import ConditionWrapper from '@/condition/ConditionWrapper'
import ConditionContainer from '@/condition/ConditionContainer'
import { mapGetters } from 'vuex'
import { convertQuestionList } from '@/question/factory'
import {getCellSettingInfo,cellSubmit, getColSettingInfo, getRowSettingInfo, colSubmitData, rowSubmitData } from '@/api/index-statistics'
import {getSurveyPreview } from '@/api/wenjuan/wjquestion'
import ComplexCalculation from './ComplexCalculation.vue'
import { html2text } from '@dygc/shared'
import SelectList from './selectList.vue'
import PreviewCalcul from './PreviewCalculData.vue'
const cellFormula={
  isComplexFormula:false,
  simpleFormula:{funcName:null,questionId:null,optionIds:null},
  complexFormula:'',
}
const batcbatchFormulahFormula={
  isDiffField:false,
  sameFieldSimpleFormula:{},
  sameFieldIsComplexFormula:false,
  sameFieldComplexFormula:'',
  diffDimensionFormulaList:[]
}
const checkQuestionTypeList=[1,2,27,32,34,37,38,39,40]

export default {
  name: 'SettingDrawer',
  components: {DataTable,ConditionWrapper,ConditionContainer,ComplexCalculation,SelectList,PreviewCalcul},
  data() {
    return {
      questionList:[],
      optionsList:[],
      simpleSelectQuestin:{issue:{validate:'num'}},
      condition: {
        matchMethod: 0,
        conditions: [
          {
            id: 1,
            leftValueType: 0,
            mainCode: null,
            mainQuestionType: null,
            mainType: null,
            operator: '',
            rightOptions: [],
            subCode: null
          }
        ]
      },
      cellsData:{
        filter:{isComplexFilter:false,simpleFilter:{surveyId:null,questionType:0,questionId:null,optionIds:null},complexFilter:{}},
        formula:{}
      },
      tableLoading: false,
      dataRangeColumns: [
        { fixed: false,align:'left', label: '维度', value: 'dimensionName', width: 100 },
        { fixed: false,align:'right', label: '选择字段', value: 'options',width: 490,headName:'headOptions' },
      ],
       page: {
        current: 1,
        pageSizes: [10, 20, 30, 40, 50],
        size: 10,
        total: 7
      },
      selectList: [],
      checkAllSource: false,
      allSelectDemo: '', //批量设置关联问卷
      ComplexFilterList:[],
      filterQuestionTypeList:[1,2,7,27,32,34,37,38,39,40],
      radioQuestionTypeList:[1,27,32,34,37,38,39,40],
      dimensionList:[],
      calculTableLoading:false,
      calculColumns:[
        { fixed: false,align:'left', label: '维度', value: 'dimensionName', fixWidth: 130 },
        { fixed: false,align:'left', label: '简单/复杂计算', value: 'calculType',fixWidth: 148,},
        { fixed: false,align:'left', label: '表达式', value: 'formulaWay',width:562},
      ],
      calculpPage:{
        current: 1,
        pageSizes: [10, 20, 30, 40, 50],
        size: 10,
        total: 7
      },
      calculSelectList:[],
      allCalculSel:{
        isComplexFormula:false,
        complexFormulaHtml:'',
        simpleFormula:{
          questionId:'',
          optionIds:[],
          funcName:'',
        }
      },
      indicatorDimensionIds:[],
      timeDimensionIds:[],
    }
  },
  props: {
    drawerType:{
      type:String,
      default:''
    },
    id:{
      type:Number,
      default:0
    },
    indexId:{
      type:Number,
      default:0
    },
  },
    watch: {
    selectList: {
      handler(v) {
        const selIds = this.selectList.map(item => item.dimensionId)
        this.cellsData.filter.simpleFilter.dimensionOptionList.forEach(item => {
          item.disableSel = selIds.includes(item.dimensionId)
          item.optionIds = selIds.includes(item.dimensionId) ? this.allSelectDemo : item.optionIds
        })
        this.$nextTick(()=>{
          this.$refs.tableRef.doLayout()
        })
      },
      deep: true
    },
    calculSelectList: {
      handler(v) {
        const selIds = this.calculSelectList.map(item => item.dimensionId)
        this.cellsData.formula.diffDimensionFormulaList.forEach(item => {
          item.disableSel = selIds.includes(item.dimensionId)
          if(selIds.includes(item.dimensionId)){
            item.formula.simpleFormula.funcName=this.allCalculSel.simpleFormula.funcName
            item.formula.simpleFormula.questionId=this.allCalculSel.simpleFormula.questionId
            item.formula.simpleFormula.questionType=this.allCalculSel.simpleFormula.questionType
            item.formula.complexFormulaHtml=this.allCalculSel.complexFormulaHtml
            item.formula.isComplexFormula=this.allCalculSel.isComplexFormula
            item.formula.simpleFormula.optionIds=this.allCalculSel.simpleFormula.optionIds
            //  if(item.formula.simpleFormula.questionType!=2){
            //   item.formula.simpleFormula.optionIds=this.allCalculSel.simpleFormula.optionIds.join(',')
            // }else{
            //   item.formula.simpleFormula.optionIds=this.allCalculSel.simpleFormula.optionIds
            // }
          }
        })
        this.$nextTick(()=>{
          this.$refs.calculTableRef.doLayout()
        })
      },
      deep: true
    },
    allCalculSel: {
      handler(v) {
        const selIds = this.calculSelectList.map(item => item.dimensionId)
        this.cellsData.formula.diffDimensionFormulaList.forEach(item => {
          item.disableSel = selIds.includes(item.dimensionId)
          if(selIds.includes(item.dimensionId)){
            item.formula.simpleFormula.funcName=this.allCalculSel.simpleFormula.funcName
            item.formula.simpleFormula.questionId=this.allCalculSel.simpleFormula.questionId
            item.formula.simpleFormula.questionType=this.allCalculSel.simpleFormula.questionType
            item.formula.complexFormulaHtml=this.allCalculSel.complexFormulaHtml
            item.formula.isComplexFormula=this.allCalculSel.isComplexFormula
            item.formula.simpleFormula.optionIds=this.allCalculSel.simpleFormula.optionIds
            // if(item.formula.simpleFormula.questionType!=2){
            //   item.formula.simpleFormula.optionIds=this.allCalculSel.simpleFormula.optionIds.join(',')
            // }else{
            //   item.formula.simpleFormula.optionIds=this.allCalculSel.simpleFormula.optionIds
            // }
            
          }
        })
        this.$forceUpdate()
        this.$nextTick(()=>{
          this.$refs.calculTableRef.doLayout()
        })
      },
      deep: true
    }
  },
computed:{
  ...mapGetters(['indexSurveyInfoList','indexStatInfo']),
    checkPageAll: {
      get() {
        return this.selectList.length > 0
      },
      set() {
        const table = this.$refs.tableRef
        if (table) {
          if(this.selectList.length > 0){
            table.clearSelection()
          }else{
            table.toggleAllSelection()
          }
        }
      }
    },
    calculCheckPageAll: {
      get() {
        return this.calculSelectList.length > 0
      },
      set() {
        const table = this.$refs.calculTableRef
        if (table) {
          if(this.calculSelectList.length > 0){
            table.clearSelection()
          }else{
            table.toggleAllSelection()
          }
        }
      }
    },
    surveyList(){
      if(this.drawerType=='cell'){
        let surveyList =[]
        if(this.indexStatInfo && this.indexStatInfo.surveyId){
          const indexObj={id:this.indexStatInfo.surveyId,name:this.indexStatInfo.surveyName,isSample:this.indexStatInfo.isSample}
          surveyList.push(indexObj)
        }
        if(this.cellsData.sourceSurveyId==this.indexStatInfo.surveyId){
          return surveyList
        }
        const obj={id:this.cellsData.sourceSurveyId,name:this.cellsData.sourceSurveyTitle,isSample:false,}
        if(obj.id){
          surveyList.push(obj)
        }
        return surveyList
      }
      if(this.drawerType=='col'){
        let surveyList =[]
        if(this.indexStatInfo && this.indexStatInfo.surveyId){
          const indexObj={id:this.indexStatInfo.surveyId,name:this.indexStatInfo.surveyName,isSample:this.indexStatInfo.isSample}
          surveyList.push(indexObj)
        }
        if(this.cellsData.surveyId==this.indexStatInfo.surveyId){
          return surveyList
        }
        const obj={id:this.cellsData.surveyId,name:this.cellsData.surveyTitle,isSample:false,}
        if(obj.id){
          surveyList.push(obj)
        }
        return surveyList
      }
      if(this.drawerType=='row'){
        let surveyList =[]
        if(this.indexStatInfo && this.indexStatInfo.surveyId){
          const indexObj={id:this.indexStatInfo.surveyId,name:this.indexStatInfo.surveyName,isSample:this.indexStatInfo.isSample}
          surveyList.push(indexObj)
        }
        if(this.cellsData.commonSurveyId){
          if(this.cellsData.commonSurveyId==this.indexStatInfo.surveyId){
            return surveyList
          }
          const obj={id:this.cellsData.commonSurveyId,name:this.cellsData.commonSurveyTitle,isSample:false,}
          if(obj.id){
            surveyList.push(obj)
          }
        }
        return surveyList
      }
    },
},
  created(){
    this.cellsData.formula = this.drawerType=='cell'?cellFormula:batcbatchFormulahFormula
  },
  mounted(){
    this.getSettingData()
  },
  methods:{
    clearOptionIds(){
      this.cellsData.filter.simpleFilter.dimensionOptionList.forEach((val,i)=>{
        // this.$set(this.cellsData.filter.simpleFilter.dimensionOptionList,i,{...val,optionIds:[]})
        val.optionIds= ''
        this.$set(this.cellsData.filter.simpleFilter.dimensionOptionList,i,{...val,optionIds:[]})
      })
      this.allSelectDemo=''
      this.$forceUpdate()

    },
    getSettingData(){
        if(this.drawerType=='cell'){
          this.getCellData()
        }
        if(this.drawerType=='col'){
          this.getColData()
        }
        if(this.drawerType=='row'){
          this.getRowData()
        }
    },
    initFilter(value,surveyId){
      let filter={
        isComplexFilter:value,
        simpleFilter:{surveyId:null,questionId:null,optionIds:null,isSample:null},
        complexFilter:null
      }
      this.condition={
        matchMethod: 0,
        surveyId:surveyId,
        conditions: [
          {
            id: 1,
            leftValueType: 0,
            mainCode: null,
            mainQuestionType: null,
            mainType: null,
            operator: '',
            rightOptions: [],
            subCode: null
          }
        ]
      }
      return filter
    },
    initFormula(value,surveyId){
      let formula={
          isComplexFormula:value,
          simpleFormula:{funcName:null,questionId:null,optionIds:null},
          complexFormula:''
        }
      return formula
    },
    getCellData(){
      getCellSettingInfo({id:String(this.id)}).then(res=>{
        if(res.data.code==0){
          let cellsData=res.data.data
          if(!cellsData.filter){
            cellsData.filter=this.initFilter(false,cellsData.sourceSurveyId)
          }
          if(!cellsData.formula){
            cellsData.formula=this.initFormula(false,cellsData.sourceSurveyId)
          }
          if(cellsData.filter?.complexFilter){
            this.condition=cellsData.filter?.complexFilter
          }
          this.indicatorDimensionIds=[cellsData.indicatorDimensionId],
          this.timeDimensionIds=[cellsData.timeDimensionId]
          this.cellsData=cellsData
        }
      })
    },
    initBatchFilter(value,list,surveyId,surveyName){
      let dimensionComplexFilterList=[]
      let simpleFilter={isSample:null,questionId:null,questionType:0,surveyId:null,dimensionOptionList:[]}
      list.forEach(val=>{
        let obj={}
        let obj1={}
        obj.dimensionId=val.dimensionId || val.timeDimensionId
        obj.dimensionName=val.dimensionName || val.timeDimensionName
        obj1.dimensionId=val.dimensionId || val.timeDimensionId
        obj1.dimensionName=val.dimensionName || val.timeDimensionName
        obj.filter={
          matchMethod: 0,
          surveyId:val.surveyId || surveyId,
          conditions: [
            {
              id: 1,
              leftValueType: 0,
              mainCode: null,
              mainQuestionType: null,
              mainType: null,
              operator: '',
              rightOptions: [],
              subCode: null
            }
          ]
        }
        if(this.indexStatInfo && this.indexStatInfo.surveyId){
        obj.surveyList=[{id:this.indexStatInfo.surveyId,name:this.indexStatInfo.surveyName,isSample:this.indexStatInfo.isSample},]
        if(val.surveyId==this.indexStatInfo.surveyId || this.indexStatInfo.surveyId==surveyId){
        }else{
          obj.surveyList.push({id:val.surveyId||surveyId,name:val.surveyTitle||surveyName,isSample:false})
        }
        }else{
          obj.surveyList=[]
          obj.surveyList.push({id:val.surveyId||surveyId,name:val.surveyTitle||surveyName,isSample:false})
        }
        
        obj1.optionIds=[]
        dimensionComplexFilterList.push(obj)
        simpleFilter.dimensionOptionList.push(obj1)
      })
      console.log(dimensionComplexFilterList,'pppp')
      let filter={
        isComplexFilter:value,
        dimensionComplexFilterList:dimensionComplexFilterList,
        simpleFilter:simpleFilter
      }
      return filter
    },
    initBatchFormula(value,list,surveyId){
      let formula={
        isDiffField:value,
        sameFieldIsComplexFormula:false,
        sameFieldComplexFormula:'',
        sameFieldSimpleFormula:{funcName:'',optionIds:[],questionId:''},
        diffDimensionFormulaList:[]
        }
        list.forEach(val=>{
          const obj={
            dimensionId:val.dimensionId || val.timeDimensionId,
            dimensionName:val.dimensionName || val.timeDimensionName,
            formula:{
              isComplexFormula:false,
              complexFormula:'',
              complexFormulaHtml:'',
              simpleFormula:{funcName:'',optionIds:[],questionId:''}
            },
            surveyId:val.surveyId || surveyId         
          }
          formula.diffDimensionFormulaList.push(obj)
        })
      return formula
    },
    getColData(){
       getColSettingInfo({colId:String(this.id),indicatorDimensionPid:this.indexId}).then(res=>{
        if(res.data.code==0){
          let cellsData=res.data.data
          this.dimensionList=this.cellsData.indicatorDimensionBaseList
          cellsData.filter=this.initBatchFilter(false,cellsData.indicatorDimensionBaseList,cellsData.surveyId,cellsData.surveyTitle)
          cellsData.formula=this.initBatchFormula(false,cellsData.indicatorDimensionBaseList,cellsData.surveyId)
          this.indicatorDimensionIds=cellsData.indicatorDimensionBaseList.map((val)=>val.dimensionId),
          this.timeDimensionIds=[cellsData.timeDimensionId]
          this.cellsData=cellsData
        }
      })
        
    },
    getRowData(){
        getRowSettingInfo({rowId:String(this.id)}).then(res=>{
       if(res.data.code==0){
          let cellsData=res.data.data
          const value=!this.indexStatInfo.surveyId && !cellsData.commonSurveyId?true:false
          cellsData.filter=this.initBatchFilter(value,cellsData.sourceList)
          cellsData.formula=this.initBatchFormula(cellsData.commonSurveyId?false:true,cellsData.sourceList)
          this.indicatorDimensionIds=[cellsData.indicatorDimensionId],
          this.timeDimensionIds=cellsData.sourceList.map((val)=>val.timeDimensionId)
          this.cellsData=cellsData
          this.dimensionList=this.cellsData.sourceList
        }
      })

    },
    clearAllCondition(){
      this.condition = {
        matchMethod: 0,
        conditions: [
          {
            id: 1,
            leftValueType: 0,
            mainCode: null,
            mainQuestionType: null,
            mainType: null,
            operator: '',
            rightOptions: [],
            subCode: null
          }
        ]
      }
    },
    copyLast(i){
      this.cellsData.filter.dimensionComplexFilterList[i].filter=cloneDeep(this.cellsData.filter.dimensionComplexFilterList[i-1].filter)
    },
    clearItemAllCondition(i){
       const condition = {
        matchMethod: 0,
        conditions: [
          {
            id: 1,
            leftValueType: 0,
            mainCode: null,
            mainQuestionType: null,
            mainType: null,
            operator: '',
            rightOptions: [],
            subCode: null
          }
        ]
      }
      this.cellsData.filter.dimensionComplexFilterList[i].filter=condition
    },
    alculationMode(type){
    //   item.issue.validate='num'
      if(type==7){
        return[{value:'SUM',name:'求和'},{value:'AVERAGE',name:'平均值'}]
      }else if(checkQuestionTypeList.includes(type)){
        return[{value:'COUNT',name:'计数'}]
      }else{
        return[]
      }
    },
    changeSelected(list) {
      this.selectList = list;
    },
    changeCalculSelected(list) {
      console.log(list,'98')
      this.calculSelectList = list;
    },
    changeBatchSel(e){
      const selIds = this.selectList.map(item => item.dimensionId)
      this.cellsData.filter.simpleFilter.dimensionOptionList.forEach(item => {
        item.disableSel = selIds.includes(item.dimensionId)
        item.optionIds = selIds.includes(item.dimensionId) ? e : item.optionIds
      })
      this.$refs.tableRef.doLayout()
    },
    changeFilter(value){
      if(this.drawerType=='cell'){
        this.cellsData.filter=this.initFilter(value,this.cellsData.sourceSurveyId)
      }
      if(this.drawerType=='col'){
        this.cellsData.filter=this.initBatchFilter(value,this.cellsData.indicatorDimensionBaseList,this.cellsData.surveyId,this.cellsData.surveyTitle)
        this.allSelectDemo=''
        this.optionsList=[]
        if(!value)this.selectList=[]
      }
      if(this.drawerType=='row'){
        this.cellsData.filter=this.initBatchFilter(value,this.cellsData.sourceList)
        this.allSelectDemo=''
        this.optionsList=[]
        if(!value)this.selectList=[]
      }
    },
    changeFormula(value){
      if(this.drawerType=='cell'){
        this.cellsData.formula=this.initFormula(value,this.cellsData.sourceSurveyId)
      }
      if(this.drawerType=='col'){
        this.cellsData.formula=this.initBatchFormula(value,this.cellsData.indicatorDimensionBaseList,this.cellsData.surveyId)
        if(value){
          this.allCalculSel={
            isComplexFormula:false,
            complexFormulaHtml:'',
            simpleFormula:{
              questionId:'',
              optionIds:[],
              funcName:'',
            }
          }
          this.calculSelectList=[]
        }
      }
      if(this.drawerType=='row'){
        this.cellsData.formula=this.initBatchFormula(value,this.cellsData.sourceList)
        if(value){
          this.allCalculSel={
            isComplexFormula:false,
            complexFormulaHtml:'',
            simpleFormula:{
              questionId:'',
              optionIds:[],
              funcName:'',
            }
          }
          this.calculSelectList=[]
        }
      }
    },
    tranComplexFormula(innerHTML,surveyId){
      const list=this.indexSurveyInfoList[surveyId]
      let newHTML=innerHTML
      let reg = /\[Q(.+?)\]/g; 
      let newValue=newHTML.match(reg)
      if(newValue){
        newValue.forEach(val=>{
        let check = val.match(/\[Q(\d+)_/)
        let fill = val.match(/\[Q(\d+)]/)
        let newVal=val
        // 填空题
        if(fill){
          let num = fill[1]
          let insertItem = list.find(item=>item.num==num)
          if(insertItem){
            newVal='${{question'+insertItem.id+'}}'
          }
        }
        // 选择题
        if(check){
          let num = check[1]
          let insertItem = list.find(item=>item.num==num)
          if(insertItem){
            newVal='${{question'+insertItem.id+'_'
            var arr = val.replace(/\[|]/g,'') .split("_")
            arr[1].split('&').forEach(a=>{
              let opt1=a.slice(0,2)
              let opt2=a.slice(2)
              if(opt1=='选项'){
                newVal+='answer'+insertItem.issue.items[opt2-1].id+'&'
              }
            })
            newVal = newVal.substring(0, newVal.length - 1); 
            newVal+='}}'
          }
        }
        newHTML=newHTML.replace(val,newVal)
      })
      }
      const innerText=html2text(newHTML)
      return{HTML:newHTML,text:innerText}
    },
    submitCell(isSubmit){
      if(this.cellsData.filter.isComplexFilter){
        let result = checkCondition(this.condition)
        // if (!result.success && !this.clearAllData) {
        if (!result.success) {
          this.$message.warning(result.message)
          return
        }
      }else{
        if(!this.cellsData.filter.simpleFilter.optionIds || this.cellsData.filter.simpleFilter.optionIds.length==0){
          this.$message.warning('请选择完整的数据字段')
          return
        }
      }
      if(this.cellsData.formula.isComplexFormula){
        if(!this.cellsData.formula.complexFormulaHtml){
          this.$message.warning('请插入复杂计算公式')
          return
        }
      }else{
        if(!this.cellsData.formula.simpleFormula.questionId){
          this.$message.warning('请选择计算字段')
          return
        }
        if(this.cellsData.formula.simpleFormula.questionType!=7&&this.cellsData.formula.simpleFormula.optionIds.length==0){
          this.$message.warning('请选择计算字段')
          return
        }
        if(!this.cellsData.formula.simpleFormula.funcName){
          this.$message.warning('请选择计算公式')
          return
        }
      }
      if(this.cellsData.filter.isComplexFilter){
        this.cellsData.filter.complexFilter=this.condition
      }else{
        this.cellsData.filter.complexFilter=null
      }
      if(this.cellsData.formula.isComplexFormula){
        let complexFormula=this.tranComplexFormula(this.cellsData.formula.complexFormulaHtml,this.cellsData.sourceSurveyId)
        this.cellsData.formula.complexFormula=complexFormula.text
        this.cellsData.formula.complexFormulaHtml=complexFormula.HTML
      }
      let data={
        id:this.cellsData.id,
        formula:this.cellsData.formula,
        filter:this.cellsData.filter
      }
      if(!isSubmit){
        return data
      }
      cellSubmit(data).then(res=>{
        if(res.data.code==0){
          this.$emit('drawreSubmit')
          this.$message.success('保存成功')
        }else{
          this.$message.error(res.data.msg)

        }
      })
    },
    submitBatch(isSubmit){
      let checkFilter=true
      let checkFormula=true
       if(this.cellsData.filter.isComplexFilter){
        try {
          this.cellsData.filter.dimensionComplexFilterList.forEach(val=>{
            let result = checkCondition(val.filter)
            // if (!result.success && !this.clearAllData) {
            if (!result.success) {
              checkFilter=false
              throw (result.message);
            }
          })
        }catch(e){
          this.$message.warning(e)
        }
      }else{
        try {
          this.cellsData.filter.simpleFilter.dimensionOptionList.forEach(val=>{
            if(!val.optionIds || val.optionIds.length==0){
              checkFilter=false
              throw ('请选择完整的数据字段');
            }
          })
        }catch(e){
          this.$message.warning(e)
        }
      }
      if(!checkFilter) return
      if(this.cellsData.formula.isDiffField){
        try{
          this.cellsData.formula.diffDimensionFormulaList.forEach(val=>{
            if(val.formula.isComplexFormula && !val.formula.complexFormulaHtml){
              checkFormula=false
              throw ('请插入复杂计算公式');
            }
            if(!val.formula.isComplexFormula){
               if(!val.formula.simpleFormula.questionId){
                checkFormula=false
                throw ('请选择计算字段');
              }
              if(val.formula.simpleFormula.questionType!=7 && (!val.formula.simpleFormula.optionIds || val.formula.simpleFormula.optionIds.length==0)){
                checkFormula=false
                throw ('请选择计算字段');
              }
              if(!val.formula.simpleFormula.funcName){
                checkFormula=false
                throw ('请选择计算公式');
              }
            }
          })
        }catch(e){
          this.$message.warning(e)
        }
      }else{
        if(this.cellsData.formula.sameFieldIsComplexFormula && !this.cellsData.formula.sameFieldComplexFormulaHtml){
          checkFormula=false
          this.$message.warning('请插入复杂计算公式')
          return 
        }
        if(!this.cellsData.formula.sameFieldIsComplexFormula){
          if(!this.cellsData.formula.sameFieldSimpleFormula.questionId){
            checkFormula=false
            this.$message.warning('请选择计算字段')
            return
          }
          if(this.cellsData.formula.sameFieldSimpleFormula.questionType!=7 && (!this.cellsData.formula.sameFieldSimpleFormula || this.cellsData.formula.sameFieldSimpleFormula.optionIds.length==0)){
            checkFormula=false
            this.$message.warning('请选择计算字段')
            return
          }
          if(!this.cellsData.formula.sameFieldSimpleFormula.funcName){
            checkFormula=false
            this.$message.warning('请选择计算公式')
            return
          }
        }
      }
      if(!checkFormula) return
      if(this.cellsData.filter.isComplexFilter){
        this.cellsData.filter.simpleFilter=null
      }else{
        this.cellsData.filter.dimensionComplexFilterList=[]
      }
      if(this.cellsData.formula.isDiffField){
        this.cellsData.formula.sameFieldSimpleFormula=null
        this.cellsData.formula.sameFieldComplexFormula=null
        this.cellsData.formula.sameFieldIsComplexFormula=false
        this.cellsData.formula.diffDimensionFormulaList.forEach(val=>{
          if(val.formula.isComplexFormula){
            val.simpleFormula=null
            let complexFormula=this.tranComplexFormula(val.formula.complexFormulaHtml,this.cellsData.surveyId || val.surveyId)
            val.formula.complexFormula=complexFormula.text
            val.formula.complexFormulaHtml=complexFormula.HTML
          }else{
            val.complexFormula=null
          }
        })
      }else{
        this.cellsData.formula.diffDimensionFormulaList=[]
        if(this.cellsData.formula.sameFieldIsComplexFormula){
          this.cellsData.formula.sameFieldSimpleFormula=null
          let complexFormula=this.tranComplexFormula(this.cellsData.formula.sameFieldComplexFormulaHtml,this.cellsData.surveyId || this.cellsData.commonSurveyId)
          this.cellsData.formula.sameFieldComplexFormula=complexFormula.text
          this.cellsData.formula.sameFieldComplexFormulaHtml=complexFormula.HTML

        }else{
          this.cellsData.formula.sameFieldComplexFormula=null
        }
      }
      if(this.drawerType=='col'){
        return this.submitCol(isSubmit)
      }
      if(this.drawerType=='row'){
        return this.submitRow(isSubmit)
      }
    },
    submitCol(isSubmit){
      if(this.cellsData.filter?.simpleFilter?.dimensionOptionList){
        this.cellsData.filter.simpleFilter.indicatorDimensionOptionList=cloneDeep(this.cellsData.filter.simpleFilter.dimensionOptionList)
        // delete this.cellsData.filter.simpleFilter.dimensionOptionList
        this.cellsData.filter.simpleFilter.indicatorDimensionOptionList.forEach(val=>{
            val.optionIds=val.optionIds.split(',')
          })
      }
      let formula=this.cellsData.formula
      formula.diffFieldIndicatorDimensionFormulaList=cloneDeep(formula.diffDimensionFormulaList)
      // delete formula.diffDimensionFormulaList
      formula.diffFieldIndicatorDimensionFormulaList.forEach(val=>{
        if(val.formula?.simpleFormula?.optionIds && !Array.isArray(val.formula?.simpleFormula?.optionIds)){
          val.formula.simpleFormula.optionIds=val.formula.simpleFormula.optionIds.split(',')
        }
      })
      let data={
        filter:{
          isComplexFilter:this.cellsData.filter.isComplexFilter,
          indicatorDimensionComplexFilterList:this.cellsData.filter.dimensionComplexFilterList,
          simpleFilter:this.cellsData.filter.simpleFilter
        },
        formula:formula,
        timeDimensionId:this.id,
        indicatorDimensionPid:this.indexId,
      }
      if(!isSubmit){
        return data
      }
      colSubmitData(data).then(res=>{
        if(res.data.code==0){
          this.$emit('drawreSubmit')
          this.$message.success('提交成功')
        }else{
          this.$message.error(res.data.msg)

        }
      })
    },
    submitRow(isSubmit){
      if(this.cellsData.filter?.simpleFilter?.dimensionOptionList){
        this.cellsData.filter.simpleFilter.timeDimensionOptionList=cloneDeep(this.cellsData.filter.simpleFilter.dimensionOptionList)
        // delete this.cellsData.filter.simpleFilter.dimensionOptionList
        this.cellsData.filter.simpleFilter.timeDimensionOptionList.forEach(val=>{
          val.optionIds=val.optionIds.split(',')
        })
      }
      let formula=this.cellsData.formula
      formula.diffFieldTimeDimensionFormulaList=cloneDeep(formula.diffDimensionFormulaList)
      formula.diffFieldTimeDimensionFormulaList.forEach(val=>{
        if(val.formula?.simpleFormula?.optionIds && !Array.isArray(val.formula?.simpleFormula?.optionIds)){
          val.formula.simpleFormula.optionIds=val.formula.simpleFormula.optionIds.split(',')
        }
      })
      // delete formula.diffDimensionFormulaList
      let data={
        filter:{
          isComplexFilter:this.cellsData.filter.isComplexFilter,
          timeDimensionComplexFilterList:this.cellsData.filter.dimensionComplexFilterList,
          simpleFilter:this.cellsData.filter.simpleFilter
        },
        formula:formula,
        indicatorDimensionId:this.id
      }
      if(!isSubmit){
        console.log(data,'999')
        return data
      }
      rowSubmitData(data).then(res=>{
        if(res.data.code==0){
          this.$emit('drawreSubmit')
          this.$message.success('提交成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })

    },
    toSubmit(){
      console.log(this.cellsData)
      if(this.drawerType=='cell'){
        this.submitCell(true)
      }else {
        this.submitBatch(true)
      }
    },

    
  }
}
</script>

<style lang="scss" scoped>
.active{
  @apply text-theme;
}
.wh-70{
  width: 70px;
}
::v-deep .el-radio-button__inner{
  color: rgba(0, 0, 0,0.65);
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  // border: 1px solid #2775E8;
  @apply border border-solid border-theme;
  background: #F0F8FF;
  color: #308AF7;
  -webkit-box-shadow: none;
  box-shadow: none;
}
::v-deep .el-radio-button--mini .el-radio-button__inner{
  padding: 5px 17px;
}
::v-deep .el-radio-button:last-child .el-radio-button__inner{
  border-radius: 0 2px 2px 0;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner{
  border-radius: 0 2px 2px 0;
}
.diff-culcal-table{
  ::v-deep .el-table__cell{
    position: static ;
  }
  ::v-deep .el-table__body-wrapper{
    position: static ;
  }
}
.wrap-time-setting{
  height: calc(100vh - 113px);
  overflow: auto;
}
.footer-time-btns{
  width: 100%;
  // width: calc(90vw - 322px);
  // right: 322px;
}
.index-setting-table{
  ::v-deep .el-table th.el-table__cell{
    background-color: #F5F5F5;
  }
  ::v-deep .el-table tr{
    background-color: #F5F5F5;
  }
  ::v-deep .el-table.data-table thead th{
    height: 36px !important;
  }
  ::v-deep .el-table.table_check_fixed .el-table__header colgroup col:first-child,
  ::v-deep .el-table.table_check_fixed .el-table__body colgroup col:first-child{
    width: 30px !important;
  }
  ::v-deep .el-table-column--selection .cell{
    padding-left: 16px !important;
    padding-right: 0 !important;
  }
  ::v-deep .el-table::before,::v-deep .el-table__fixed::before{
    height: 0px;
  }
}

</style>
